import { apiClient } from '@/lib/api/client'
import type { Commission } from '@/types/entities'

// What PATCH /artworks/:id/commissions/:key takes (handlers/artwork-handler.js updateCommission).
export interface UpdateCommissionData {
  sizeId: number
  frameTypeId: number
  // GBP the artist earns per sale. Ignored when isCustom is false.
  commission: number
  // false puts the size back on the default commission.
  isCustom: boolean
}

export const commissionApi = {
  // Get commissions for an artwork
  getCommissions: async (artworkId: number): Promise<Commission[]> => {
    const response = await apiClient.get(`/api/artworks/${artworkId}/commissions`)
    return response.data
  },

  // Update one size + product type. Returns the artwork's commissions after the change.
  updateCommission: async (
    artworkId: number,
    data: UpdateCommissionData
  ): Promise<Commission[]> => {
    const response = await apiClient.patch(
      `/api/artworks/${artworkId}/commissions/${data.sizeId}-${data.frameTypeId}`,
      data
    )
    return response.data
  },
}
